import { Component } from '@angular/core';
import { MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-session-timeout-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatButtonModule, MatDialogActions, MatDialogContent],
  templateUrl: './session-timeout-dialog.component.html',
  styleUrl: './session-timeout-dialog.component.scss'
})
export class SessionTimeoutDialogComponent {
  constructor(public dialogRef: MatDialogRef<SessionTimeoutDialogComponent>) {}

  // Re-login button click - closes the dialog so the caller can redirect the user to the login page
  onReLogin(): void {
    this.dialogRef.close('relogin');
  }
}
